import { ArchiveCogOutlineIcon } from './ArchiveCogOutlineIcon';

/**
 * author: Colton Wiscombe
 * id FD6CA806-C4D6-4D5E-AA3B-4292EE225734
 * name archive-cog-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-cog-outline.svg
 * tags
 * - Settings 
 */
export const BoxCogOutlineIcon = ArchiveCogOutlineIcon;
export default BoxCogOutlineIcon